import * as angular from 'angular';

import { IRequestService } from '../request.service';

export interface IApprovalResultsService {
    get(guid: string, beginDate: string, endDate: string): angular.IPromise<any>;
}

export class ApprovalResultsService implements IApprovalResultsService {

    static serviceId = 'approvalResultsService';
    static $inject = ['requestService', '$q'];

    constructor(
        private _requestService: IRequestService,
        private _$q: angular.IQService
    ) {
    }

    get(guid: string, beginDate: string, endDate: string): angular.IPromise<any> {
        return this._requestService.getAtV1(
            'approvalResults',
            { groupGuid: guid, beginDate: beginDate, endDate: endDate }
        );
    }
}